import { render, staticRenderFns } from "./CAvatar.vue?vue&type=template&id=01c8d919"
import script from "./CAvatar.vue?vue&type=script&lang=js"
export * from "./CAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports